import React, { useRef, useState } from 'react';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
import { LiveBuyersBar } from './components/LiveBuyersBar';
const CHECKOUT = 'https://recetario-idol.impultienda.ar/checkout';
const PRECIO = '17';
const VALOR_TOTAL = '57';
const tomos = [{
  n: 1,
  t: 'El Menú Secreto Antes de un Comeback',
  s: 'Lo que se cocina en la semana más exigente de un idol, receta por receta'
}, {
  n: 2,
  t: 'Desayunos de Entrenamiento',
  s: 'Desayunos coreanos calientes y con proteína, listos en menos de 15 minutos'
}, {
  n: 3,
  t: 'Comidas Entre Ensayos',
  s: 'Platos rápidos que se comen en 20 minutos y no te dejan con sueño'
}, {
  n: 4,
  t: 'Noches de Comfort Food',
  s: 'Los cuatro jjigae clásicos, en una sola olla y con el picante a tu medida'
}, {
  n: 5,
  t: 'Snacks de Maratón de Dramas',
  s: 'Tteokbokki, pollo frito coreano y todo lo que acompaña una maratón'
}, {
  n: 6,
  t: 'Comida y Postres para Celebrar con el Fandom',
  s: 'Galbi, bingsu y una mesa completa para compartir en grupo'
}];
const muestras = [{
  t: 'Bibimbap energético de camarín',
  d: 'Se arma la noche anterior y se mezcla recién al comer',
  tomo: 1
}, {
  t: 'Gukbap simplificado',
  d: 'Sopa con arroz lista en menos de 8 minutos',
  tomo: 2
}, {
  t: 'Japchae exprés',
  d: 'Fideos de vidrio salteados en una sola sartén',
  tomo: 3
}, {
  t: 'Kimchi jjigae clásico',
  d: 'El guiso coreano por excelencia, con kimchi bien fermentado',
  tomo: 4
}, {
  t: 'Tteokbokki clásico',
  d: 'El snack callejero más famoso de Corea, hecho en casa',
  tomo: 5
}];
const bonos = [{
  n: 1,
  t: 'Guía de Despensa Coreana Express',
  d: 'Qué comprar, sustitutos y dónde conseguir cada ingrediente.'
}, {
  n: 2,
  t: 'Planificador Semanal de Comidas Idol',
  d: 'Combina las recetas de los 6 tomos en una semana real, con lista de compras.'
}, {
  n: 3,
  t: 'Checklist de una Viewing Party Perfecta',
  d: 'Tiempos, cantidades y roles para organizar una reunión con el fandom.'
}, {
  n: 4,
  t: 'Glosario Visual de Banchan',
  d: 'Los acompañamientos coreanos y con qué plato va cada uno.'
}, {
  n: 5,
  t: 'Guía de Picante para Principiantes',
  d: 'Ajusta el picante de cada receta a tu tolerancia, sin perder sabor.'
}];
const faqs = [{
  q: '¿Necesito experiencia cocinando comida coreana?',
  a: 'No. Cada receta trae cantidades exactas y pasos numerados, y el recetario empieza por platos simples. Si es tu primera vez con estas recetas, la Guía de Despensa te dice qué comprar primero.'
}, {
  q: '¿Voy a conseguir los ingredientes?',
  a: 'Sí. Las recetas usan ingredientes que se consiguen fuera de Corea, y el Bono 1 te da sustitutos para cuando algo no aparece, más una guía de qué tipo de tienda buscar.'
}, {
  q: '¿Es una dieta o un plan para bajar de peso?',
  a: 'No. Es un recetario de cocina coreana real, organizado por momentos del día. No promete resultados de peso ni reemplaza la indicación de un nutricionista.'
}, {
  q: '¿Es muy picante?',
  a: 'Tú decides. Cada receta picante se puede hacer suave, y el Bono 5 te explica cómo bajar o subir el picante en cada plato del libro.'
}, {
  q: '¿Cómo lo recibo?',
  a: 'Apenas se aprueba el pago te llega un email con el acceso a los 6 tomos y los 5 bonos en PDF, para leerlos en el celular, la tablet o imprimirlos.'
}, {
  q: `¿Es un pago único?`,
  a: `Sí. Pagas ${PRECIO} USD una sola vez. No hay suscripción ni cobros futuros.`
}];
const slides = [{
  src: 'https://naturia-assets.pages.dev/recetario-idol/1-por-que-bibimbap.webp',
  alt: '¿Por qué bibimbap? Carbohidrato, proteína, vegetales y grasa buena en un solo recipiente'
}, {
  src: 'https://naturia-assets.pages.dev/recetario-idol/2-ingredientes.webp',
  alt: 'Ingredientes del bibimbap para 1 porción abundante'
}, {
  src: 'https://naturia-assets.pages.dev/recetario-idol/3-pasos-1-a-4.webp',
  alt: 'Cómo hacer el bibimbap, pasos 1 a 4'
}, {
  src: 'https://naturia-assets.pages.dev/recetario-idol/4-pasos-5-a-7.webp',
  alt: 'Cómo hacer el bibimbap, pasos 5 a 7'
}, {
  src: 'https://naturia-assets.pages.dev/recetario-idol/5-variacion-sin-carne.webp',
  alt: 'Variación sin carne: tofu firme salteado en cubos'
}];
const Carrusel = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [actual, setActual] = useState(0);
  const ir = (i: number) => {
    const el = ref.current;
    if (!el) return;
    const n = (i + slides.length) % slides.length;
    el.scrollTo({
      left: n * el.clientWidth,
      behavior: 'smooth'
    });
    setActual(n);
  };
  return <div className="relative mx-auto max-w-md" data-id="element-0" data-mp="14wn9epyx0npn">
      <div ref={ref} onScroll={e => setActual(Math.round(e.currentTarget.scrollLeft / e.currentTarget.clientWidth))} className="flex snap-x snap-mandatory overflow-x-auto rounded-2xl shadow-xl [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-1" data-mp="14uu0t54qrtf0">
        {slides.map((s, i) => <img key={s.src} src={s.src} alt={s.alt} width={900} height={1125} loading={i === 0 ? 'eager' : 'lazy'} className="h-auto w-full shrink-0 snap-center" data-id="element-2" data-mp="3klq3pu5t3w9n" data-mpi={i} />)}
      </div>
      <button aria-label="Anterior" onClick={() => ir(actual - 1)} className="absolute left-2 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-slate-950/70 text-xl text-white" data-id="element-3" data-mp="1w2c3xcufw65o">‹</button>
      <button aria-label="Siguiente" onClick={() => ir(actual + 1)} className="absolute right-2 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-slate-950/70 text-xl text-white" data-id="element-4" data-mp="29vtmovfaxeun">›</button>
      <div className="mt-4 flex justify-center gap-2" data-id="element-5" data-mp="2jt82cstehzlw">
        {slides.map((s, i) => <button key={s.src} aria-label={`Ir a la imagen ${i + 1}`} onClick={() => ir(i)} className={`h-2.5 rounded-full transition-all ${i === actual ? 'w-6 bg-violet-600' : 'w-2.5 bg-slate-300'}`} data-id="element-6" data-mp="2nv32htzli6y3" data-mpi={i} />)}
      </div>
    </div>;
};
const Cta = ({
  children,
  full = false,
  href = CHECKOUT
}: {
  children: React.ReactNode;
  full?: boolean;
  href?: string;
}) => <a href={href} className={`inline-flex items-center justify-center rounded-xl bg-violet-600 px-8 py-4 text-center text-lg font-semibold text-white shadow-lg shadow-violet-600/30 transition hover:bg-violet-700 ${full ? 'w-full' : ''}`} data-id="element-7" data-mp="yihp32a4xsgx">
    {children}
  </a>;
const ImgHueco = ({
  id,
  texto,
  medida
}: {
  id: string;
  texto: string;
  medida: string;
}) => <div id={id} className="flex aspect-[4/3] w-full flex-col items-center justify-center rounded-2xl border-2 border-dashed border-violet-300 bg-violet-50 p-6 text-center text-violet-700" data-id="element-8" data-mp="25se109und4yb">
    <span className="font-semibold" data-id="element-9" data-mp="2fqaa6w40xpts">{texto}</span>
    <span className="mt-1 text-sm" data-id="element-10" data-mp="2fpipigbytcia">{medida}</span>
  </div>;
export function App() {
  const [abierta, setAbierta] = useState<number | null>(0);
  return <div className="min-h-screen bg-white text-slate-900" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-11" data-mp="2pi7tkq56ro3l">
      <style data-id="element-12" data-mp="33hfsdhxfsu79">{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Poppins:wght@500;600&display=swap'); h1,h2,h3{font-family:Poppins,sans-serif} html{scroll-behavior:smooth} @media (prefers-reduced-motion: reduce){html{scroll-behavior:auto}}`}</style>

      {/* Barra superior */}
      <div className="bg-slate-950 px-4 py-2 text-center text-sm text-white" data-id="element-13" data-mp="3n1y5gxvbn3ny">
        Oferta de lanzamiento: <span className="font-semibold text-violet-300" data-id="element-14" data-mp="38576uqth1vze">de {VALOR_TOTAL} USD a {PRECIO} USD</span> por tiempo limitado
      </div>

      {/* 1. Hero */}
      <section className="bg-slate-950 px-5 pb-16 pt-12 text-white" data-id="element-15" data-mp="2zcvfn2qja4id">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-16" data-mp="343vbe4nx2gja">
          <span className="inline-block rounded-full bg-violet-500/15 px-4 py-1 text-sm font-medium text-violet-300" data-id="element-17" data-mp="345ycpkuirw3b">
            6 tomos + 5 bonos · Recetas coreanas reales
          </span>
          <h1 className="mt-5 text-4xl font-semibold leading-tight md:text-5xl" data-id="element-18" data-mp="2uebv96rl90s4">
            Deja de buscar recetas coreanas sueltas en diez videos distintos
          </h1>
          <p className="mt-5 text-lg text-slate-300" data-id="element-19" data-mp="2kekx8v3tk3na">
            <span className="font-semibold text-white" data-id="element-20" data-mp="30vdn6ieqff8t">Recetario Idol: Cocina Coreana Real</span> reúne en un solo
            sistema lo que comen los idols de K-pop en cada momento de su rutina: desayunos, comidas entre ensayos,
            guisos de la noche, snacks de maratón y comida para celebrar.
          </p>
          <div className="mt-8 w-full max-w-md" data-id="element-21" data-mp="2lymipuq7bdcc">
            <img id="img-producto" src="https://cdn.magicpatterns.com/uploads/2Qj6T7W4rnWesuZnk5fSNZ/finally_-_Editado.webp" alt="Caja del Recetario Idol: Cocina Coreana Real con los 6 tomos" className="mx-auto h-auto w-full" data-id="element-22" data-mp="2lxuzljdsj82y" />
          </div>
          <div className="mt-8 w-full sm:w-auto" data-id="element-23" data-mp="284lo9d6a8chs">
            <Cta full href="#oferta" data-id="element-24" data-mp="238obfgu89o9r">¡Sí! Quiero el recetario</Cta>
          </div>
          <p className="mt-4 text-sm text-slate-400" data-id="element-25" data-mp="1y91w91uu9xyb">
            <span className="text-slate-500 line-through" data-id="element-26" data-mp="1yamsqx0prqyt">{VALOR_TOTAL} USD</span>{' '}
            <span className="font-semibold text-white" data-id="element-27" data-mp="1u7gmhpdlpzsc">{PRECIO} USD</span> · pago único
          </p>
        </div>
      </section>

      {/* 2. Dolor */}
      <section className="px-5 py-16" data-id="element-28" data-mp="dpygv280h0sq">
        <div className="mx-auto max-w-3xl" data-id="element-29" data-mp="dows5uy2ofsj">
          <h2 className="text-center text-3xl font-semibold" data-id="element-30" data-mp="ipkrd3wgg2xu">¿Te suena familiar?</h2>
          <ul className="mt-8 space-y-4 text-lg" data-id="element-31" data-mp="inrnfwd87wtj">
            {['Ves un plato en un drama, buscas la receta y encuentras diez versiones que no coinciden.', 'La receta pide ingredientes que no tienes idea de dónde conseguir.', 'Terminas cocinando siempre lo mismo porque no sabes por dónde seguir.', 'El picante te queda imposible de comer o completamente sin gracia.'].map(p => <li key={p} className="flex gap-3 rounded-xl bg-slate-100 p-4" data-id="element-32" data-mp="3w2wbctm1b1fi">
                <span className="mt-1 h-3 w-3 shrink-0 rounded-full bg-violet-600" data-id="element-33" data-mp="4quwlux3yfcn" />
                <span data-id="element-34" data-mp="33gbgvka9i97q">{p}</span>
              </li>)}
          </ul>
          <p className="mt-8 text-center text-lg" data-id="element-35" data-mp="33dz3lkfg8n10">
            Ya sabes que te encanta la comida coreana. <span className="font-semibold" data-id="element-36" data-mp="38ctnyqt2ejn8">Lo que falta es un sistema.</span>
          </p>
        </div>
      </section>

      {/* 3. Lo que incluye */}
      <section id="incluye" className="bg-slate-950 px-5 py-16 text-white" data-id="element-37" data-mp="2k56rjhsytyo1">
        <div className="mx-auto max-w-6xl" data-id="element-38" data-mp="2p4rq3r484508">
          <p className="text-center text-sm font-medium uppercase tracking-wider text-violet-300" data-id="element-39" data-mp="2p5uf1thzjxdi">Lo que incluye</p>
          <h2 className="mt-2 text-center text-3xl font-semibold" data-id="element-40" data-mp="2u2behjumxy5w">El recetario completo de 6 tomos</h2>
          <p className="mx-auto mt-3 max-w-2xl text-center text-slate-300" data-id="element-41" data-mp="1wej75x1v5gkl">
            Organizado por momento del día, como la rutina de un idol. Elige el momento, abre el tomo y cocina.
          </p>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-42" data-mp="26cywpvl8shrz">
            {tomos.map(t => <div key={t.n} className="rounded-2xl border border-slate-800 bg-slate-900 p-6" data-id="element-43" data-mp="2b7mmryvw9k8o">
                <span className="text-sm font-medium text-violet-300" data-id="element-44" data-mp="1do1qwry7wdg4">Tomo {t.n}</span>
                <h3 className="mt-2 text-xl font-semibold" data-id="element-45" data-mp="1ino10sir1dkp">{t.t}</h3>
                <p className="mt-2 text-slate-300" data-id="element-46" data-mp="3vzs61hd7vsqe">{t.s}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 4. Muestras */}
      <section className="px-5 py-16" data-id="element-47" data-mp="3rvsyho9x0496">
        <div className="mx-auto max-w-4xl" data-id="element-48" data-mp="3myaso6r7255e">
          <h2 className="text-center text-3xl font-semibold" data-id="element-49" data-mp="3mwzi9o38tz5b">Un vistazo a lo que vas a cocinar</h2>
          <div className="mt-8 space-y-3" data-id="element-50" data-mp="3hzhian77eu9g">
            {muestras.map(m => <div key={m.t} className="flex flex-col justify-between gap-1 rounded-xl border border-slate-200 p-5 sm:flex-row sm:items-center" data-id="element-51" data-mp="3d0wj8r3ougml">
                <div data-id="element-52" data-mp="387tk83g56ez0">
                  <h3 className="font-semibold" data-id="element-53" data-mp="3482xqbxnel0a">{m.t}</h3>
                  <p className="text-slate-600" data-id="element-54" data-mp="348ukqyd6jaey">{m.d}</p>
                </div>
                <span className="text-sm font-medium text-violet-700" data-id="element-55" data-mp="2zaaxmumunsl0">Tomo {m.tomo}</span>
              </div>)}
          </div>
          <p className="mt-6 text-center text-slate-600" data-id="element-56" data-mp="2u9ddicia4ogv">Y más de 30 recetas en total, todas paso a paso.</p>
        </div>
      </section>

      {/* 4b. Carrusel: una receta por dentro */}
      <section className="bg-slate-950 px-5 py-16 text-white" data-id="element-57" data-mp="2flv6h7h8vhra">
        <div className="mx-auto max-w-6xl" data-id="element-58" data-mp="2kn2ftaz1cp02">
          <p className="text-center text-sm font-medium uppercase tracking-wider text-violet-300" data-id="element-59" data-mp="2knua8igwcgor">Así se ve por dentro</p>
          <h2 className="mt-2 text-center text-3xl font-semibold" data-id="element-60" data-mp="26p4eb65tcn1z">Una receta completa, página por página</h2>
          <p className="mx-auto mt-3 max-w-2xl text-center text-slate-300" data-id="element-61" data-mp="2ydxoam5mh434">El bibimbap energético del Tomo 1, tal como lo vas a encontrar en el recetario.</p>
          <div className="mt-10" data-id="element-62" data-mp="33cit6yvtkbxw"><Carrusel data-id="element-63" data-mp="33f51x1ug4xhp" /></div>
        </div>
      </section>

      {/* 5. Bonos */}
      <section className="bg-slate-100 px-5 py-16" data-id="element-64" data-mp="2pl45wfuvpol1">
        <div className="mx-auto max-w-6xl" data-id="element-65" data-mp="2tmpfnsc49mr0">
          <h2 className="text-center text-3xl font-semibold" data-id="element-66" data-mp="2tlo1hezt0k52">Y además, 5 bonos incluidos</h2>
          <p className="mx-auto mt-3 max-w-2xl text-center text-slate-600" data-id="element-67" data-mp="3hb8qaein2bm9">Vienen con el recetario, sin costo extra.</p>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-68" data-mp="3m5mqcu88x6x9">
            {bonos.map(b => <div key={b.n} className="rounded-2xl bg-white p-6 shadow-sm" data-id="element-69" data-mp="1amqal9wtceml">
                <span className="text-sm font-medium text-violet-700" data-id="element-70" data-mp="15ooqclnni99j">Bono {b.n}</span>
                <h3 className="mt-2 text-lg font-semibold" data-id="element-71" data-mp="1kdb4wl5gewzp">{b.t}</h3>
                <p className="mt-2 text-slate-600" data-id="element-72" data-mp="1ffje5ugjpgx3">{b.d}</p>
                <p className="mt-4 text-sm font-semibold text-green-700" data-id="element-73" data-mp="1fg1fv6lz8nce">✓ Incluido</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 6. No es otro recetario */}
      <section className="px-5 py-16" data-id="element-74" data-mp="ms5cxk5tdz76">
        <div className="mx-auto max-w-6xl" data-id="element-75" data-mp="11nv2tte4ewh6">
          <h2 className="text-center text-3xl font-semibold" data-id="element-76" data-mp="11ommc5ug13r3">Esto NO es otro recetario más</h2>
          <p className="mt-2 text-center text-lg text-slate-600" data-id="element-77" data-mp="wnqh9oycvbk3">Es un sistema completo para tener comida coreana real en tu mesa todos los días.</p>
          <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-78" data-mp="2d4utkkktl393">
            {[['Recetas reales, paso a paso', 'Cantidades exactas y pasos numerados, sin adivinar.'], ['Ingredientes que se consiguen', 'Pensado para cocinar fuera de Corea, con sustitutos.'], ['Organizado por momento del día', 'Desayuno, entre ensayos, noche, maratón y celebración.']].map(([t, d]) => <div key={t} className="rounded-2xl border border-slate-200 p-6 text-center" data-id="element-79" data-mp="qmq8vuv76ve3">
                <h3 className="text-lg font-semibold" data-id="element-80" data-mp="vnnnxykwv9bd">{t}</h3>
                <p className="mt-2 text-slate-600" data-id="element-81" data-mp="10lp7ekm91and">{d}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 8. Oferta */}
      <div id="oferta" aria-hidden="true" data-id="element-82" data-mp="15jhamascgj6v" />
      <LiveBuyersBar data-id="element-83" data-mp="15ifptelj0iby" />
      <section className="bg-slate-950 px-5 py-16 text-white" data-id="element-84" data-mp="1aaz0o3stwzd2">
        <div className="mx-auto max-w-2xl text-center" data-id="element-85" data-mp="1adlh6sxp6p7f">
          <p className="text-sm font-medium uppercase tracking-wider text-violet-300" data-id="element-86" data-mp="1ec12mse4rpiq">Oferta especial de lanzamiento</p>
          <h2 className="mt-2 text-3xl font-semibold" data-id="element-87" data-mp="1jdqfmdkwyd9g">Recetario Idol completo</h2>
          <img src="https://cdn.magicpatterns.com/uploads/2Qj6T7W4rnWesuZnk5fSNZ/finally_-_Editado.webp" alt="Caja del Recetario Idol: Cocina Coreana Real con los 6 tomos" className="mx-auto mt-8 h-auto w-full max-w-md" data-id="element-88" data-mp="1ocbcq44vcgto" />
          <ul className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3 font-semibold" data-id="element-89" data-mp="1tesp7nmlz10j">
            {['6 tomos completos', '5 bonos incluidos', 'Más de 30 recetas', 'Ingredientes que se consiguen'].map(x => <li key={x} className="flex items-center gap-2" data-id="element-90" data-mp="1kh8nkdku32pe"><span className="text-violet-400" data-id="element-91" data-mp="2h67w7tpby6i4">✓</span>{x}</li>)}
          </ul>
          <p className="mt-8 flex flex-wrap items-baseline justify-center gap-x-4" data-id="element-92" data-mp="2c6ljdldeys9u">
            <span className="text-2xl font-semibold text-slate-500 line-through" data-id="element-93" data-mp="2c8oh6rkt5pp4">{VALOR_TOTAL} USD</span>
            <span className="text-6xl font-semibold text-violet-400" data-id="element-94" data-mp="27dimb39fh0ow">{PRECIO}</span>
            <span className="text-xl font-semibold text-violet-400" data-id="element-95" data-mp="23e1iee9ngblu">USD HOY</span>
          </p>
          <div className="mx-auto mt-8 max-w-lg" data-id="element-96" data-mp="2zxh6i56xczar"><Cta full data-id="element-97" data-mp="2v5pr8qt7yfzx">⚡ ¡Sí! Lo quiero hoy</Cta></div>
          <p className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-medium uppercase tracking-wide text-slate-300" data-id="element-98" data-mp="2v3wjt9as7rqv">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap" data-id="element-99" data-mp="y6qs2l7mw0ry"><LockIcon className="h-4 w-4 text-slate-400" aria-hidden="true" data-id="element-100" data-mp="y9364na9tqzq" /> Pago seguro</span>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap" data-id="element-101" data-mp="jg1g3gmcmhn1"><ShieldCheckIcon className="h-4 w-4 text-slate-400" aria-hidden="true" data-id="element-102" data-mp="ofw51emkcx5g" /> Garantía de 7 días</span>
          </p>
        </div>
      </section>

      {/* 9. Garantía */}
      <section className="bg-slate-100 px-5 py-12" data-id="element-103" data-mp="fgsl68fkodpw">
        <div className="mx-auto max-w-3xl text-center" data-id="element-104" data-mp="fefv17znux1r">
          <h2 className="text-2xl font-semibold" data-id="element-105" data-mp="kb9th7duz3c">Garantía de 7 días</h2>
          <p className="mt-3 text-slate-700" data-id="element-106" data-mp="5i3066sdqd5f">
            Abrís los 6 tomos. Revisás los 5 bonos. Si en 7 días no es lo que esperabas, te devolvemos el 100%.

Si en los primeros días algo no te funciona, escríbenos contándonos qué receta probaste y te ayudamos a resolverlo!
          </p>
        </div>
      </section>

      {/* 10. FAQ */}
      <section className="px-5 py-16" data-id="element-107" data-mp="3kf6btpjgoduu">
        <div className="mx-auto max-w-3xl" data-id="element-108" data-mp="3kc26gou9fc2l">
          <h2 className="text-center text-3xl font-semibold" data-id="element-109" data-mp="3fgcypy836ov7">Preguntas frecuentes</h2>
          <div className="mt-8 space-y-3" data-id="element-110" data-mp="3u4hk59yixeho">
            {faqs.map((f, i) => <div key={f.q} className="rounded-xl border border-slate-200" data-id="element-111" data-mp="3u614pcr7qbp9" data-mpi={i}>
                <button className="flex w-full items-center justify-between gap-4 p-5 text-left font-semibold" onClick={() => setAbierta(abierta === i ? null : i)} data-id="element-112" data-mp="3pc6m6cncg2rr">
                  {f.q}
                  <span className="text-violet-700" data-id="element-113" data-mp="2xddwha7dwab">{abierta === i ? '−' : '+'}</span>
                </button>
                {abierta === i && <p className="px-5 pb-5 text-slate-700" data-id="element-114" data-mp="gvbrvlkm3qpa">{f.a}</p>}
              </div>)}
          </div>
        </div>
      </section>

      {/* 11. Cierre */}
      <section className="bg-slate-950 px-5 py-16 text-center text-white" data-id="element-115" data-mp="2ipu9srhxpa0p">
        <div className="mx-auto max-w-3xl" data-id="element-116" data-mp="2dqhquhu6on3e">
          <h2 className="text-3xl font-semibold" data-id="element-117" data-mp="2drspk38rv4nn">Una última pregunta</h2>
          <p className="mt-4 text-lg text-slate-300" data-id="element-118" data-mp="1rvr25pzipxsw">
            ¿Vas a seguir buscando recetas sueltas cada vez que se te antoje un plato coreano, o vas a abrir un solo
            recetario con todo listo para empezar hoy?
          </p>
          <p className="mt-6" data-id="element-119" data-mp="21oopqajdacyd"><span className="text-slate-500 line-through" data-id="element-120" data-mp="26lovekcb1doy">{VALOR_TOTAL} USD</span>{' '}<span className="text-3xl font-semibold" data-id="element-121" data-mp="26nrl139jp4t5">{PRECIO} USD</span></p>
          <div className="mt-6" data-id="element-122" data-mp="18z801kn4ta5u"><Cta data-id="element-123" data-mp="1901248b5bbhn">¡Sí! Lo quiero hoy</Cta></div>
          <p className="mt-3 text-sm text-slate-400" data-id="element-124" data-mp="1dwhph0aitlto">Pago único. Sin suscripción. Acceso inmediato.</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="px-5 py-8 text-center text-sm text-slate-500" data-id="element-125" data-mp="1iy72uml7ubkx">
        <p data-id="element-126" data-mp="1nvys18uh7jlf">© 2026 Naturia. Todos los derechos reservados.</p>
        <p className="mx-auto mt-2 max-w-2xl" data-id="element-127" data-mp="2ubj7v0spp08o">
          Recetas inspiradas en patrones generales de la industria del entretenimiento coreano. Naturia no tiene relación
          con ningún artista, grupo ni agencia de K-pop. Este recetario no es un plan de alimentación ni reemplaza la
          indicación de un profesional de la salud.
        </p>
      </footer>
    </div>;
}